export default {
  flujo: () => require('./forms/dntFileFlow').default(),
  fileFlow: () => require('./forms/fileRepositoryFlow').default(),
  massiveFlow: () => require('./forms/repositoryMassiveFlow').default(),
  newFlow: () => require('./forms/newFlow').default(),
  newFlowEp: () => require('./forms/newFlowEp').default(),
};
